import Splide from '@splidejs/splide';
import Player from '@vimeo/player';

const __MOBILE_BREAKPOINT = 900;
// const __MOBILE_SMALL_BREAKPOINT = 480;

const dom = function (callback) {
  document.readyState === 'complete' ||
  (document.readyState !== 'loading' && !document.documentElement.doScroll)
    ? callback()
    : document.addEventListener('DOMContentLoaded', callback);
};

dom(function () {
  loadPage();

  let lastScrollTop = 0,
    videoPlayer;

  window.addEventListener('load', function () {});

  window.addEventListener('scroll', function () {
    changeMenuTheme();
    stickySubmenu();
    animateGridItem();
    hideMainMenu();
  });

  window.addEventListener('resize', function () {
    redesignVimeo();
    resizeIcons();
    submenuLoad();
    menuReload();
    onResizeLoad();
  });

  // ***** EVENTS ***** //

  window.dataLayer = window.dataLayer || [];
  var wpcf7Elm = document.querySelectorAll('.wpcf7-form');

  wpcf7Elm.forEach(function (item) {
    item.addEventListener(
      'wpcf7submit',
      function (event) {
        let formtype = '',
          isReklamation = false;
        if (event.detail.contactFormId == '339') {
          formtype = 'Reservdelsbeställning';
        } else if (event.detail.contactFormId == '338') {
          formtype = 'Reklamation';
          isReklamation = true;
        } else if (event.detail.contactFormId == '342') {
          formtype = 'Ordering Spare Parts';
        } else if (event.detail.contactFormId == '346') {
          formtype = 'Claims Report';
          isReklamation = true;
        }

        if (formtype != '') {
          window.dataLayer.push({
            event: 'form_submission',
            formType: formtype,
          });
        }
        if (isReklamation) {
          updateCaseNumber();
        }
      },
      false
    );
  });

  // Cookie Banner
  // prettier-ignore
  document.querySelector('.cookie-banner-close').addEventListener('click', function () {
      localStorage.setItem('setCloseSorlingBanner', 'set');
      document
        .querySelector('.cookie-banner-container')
        .classList.remove('active');
    });

  if (localStorage.getItem('setCloseSorlingBanner') === 'set') {
    document.querySelector('.cookie-banner-container').style.display = 'none';
  } else {
    document.querySelector('.cookie-banner-container').classList.add('active');
  }

  // Hamburger menu on click
  // prettier-ignore
  document.querySelector('.hamburger').addEventListener('click', function () {
    onClickMenu(this);
  });

  document.querySelector('.menu-item').addEventListener('click', function () {
    onClickMenu(this);
  });

  // dropdown on click
  document.querySelectorAll('.drop-content-wrapper').forEach(function (item) {
    dropdownClick(item);
  });

  // Home hero nav button
  document.querySelectorAll('.nav-button').forEach(function (item) {
    item.addEventListener('click', function () {
      const bodyTop =
        document.querySelector('.main-wrapper').getBoundingClientRect().top +
        document.documentElement.scrollTop;

      scroll({
        top: bodyTop,
        behavior: 'smooth',
      });
    });
  });

  // show submenu main title on mobile except language drop on mobile
  document.querySelectorAll('.submenu-drop').forEach(function (item) {
    item.addEventListener('click', function () {
      let submenuList;

      if (item.classList.contains('lang-drop')) {
        submenuList = item.closest('.language-list').querySelector('ul');
      } else {
        submenuList = item.closest('.submenu-content').querySelector('ul');
      }

      if (!submenuList.classList.contains('active')) {
        submenuList.classList.add('active');
        item.classList.add('expand');
      } else {
        submenuList.classList.remove('active');
        item.classList.remove('expand');
      }
    });
  });

  // social icons on hover
  document.querySelectorAll('.social-icon').forEach(function (item) {
    const wW = window.innerWidth;

    item.addEventListener('mouseenter', function () {
      if (wW > __MOBILE_BREAKPOINT) {
        if (!item.classList.contains('active')) {
          document.querySelectorAll('.social-icon').forEach(function (item) {
            item.classList.add('small');
          });

          item.classList.remove('small');
          item.classList.add('active');
        }
      }
    });

    item.addEventListener('mouseleave', function () {
      if (wW > __MOBILE_BREAKPOINT) {
        if (item.classList.contains('active')) {
          document.querySelectorAll('.social-icon').forEach(function (item) {
            item.classList.remove('small');
          });
          item.classList.remove('active');
        }
      }
    });
  });

  // submenu: product on click
  document
    .querySelectorAll('.product-submenu-wrapper.submenu-wrapper li')
    .forEach(function (item) {
      item.addEventListener('click', function () {
        if (!item.classList.contains('active')) {
          const itemSlug = item.dataset.slug;

          document
            .querySelector('.tab-wrapper.active')
            .classList.remove('active');
          document.getElementById(itemSlug).classList.add('active');

          submenuChange(item, 'plats', itemSlug);
        }
      });
    });

  // submenu: news on click
  document
    .querySelectorAll('.news-submenu-wrapper.submenu-wrapper li')
    .forEach(function (item) {
      item.addEventListener('click', function () {
        let year = this.dataset.year;

        const param = {};
        param['action'] = 'get_news_content';
        param['year'] = year;
        const url = document.getElementById('newsAjaxURL').dataset.url;

        // prettier-ignore
        jQuery.ajax({
          url: url,
          type: 'post',
          data: param,
          error: function(errorThrown){console.log(errorThrown);
    
          },
          beforeSend: function () {
            
          },
          success: function(response) {
              submenuChange(item, 'y', year);
              document.querySelector('.nyheter-main-wrapper .body-wrapper').innerHTML = response; 

              // register dropdown on click
              document.querySelectorAll('.drop-content-wrapper').forEach(function (item) {
                dropdownClick(item);
              });
          },
        });
      });
    });

  // submenu: contact on click
  document
    .querySelectorAll('.contact-submenu-wrapper.submenu-wrapper li')
    .forEach(function (item) {
      item.addEventListener('click', function () {
        if (!item.classList.contains('active')) {
          const itemSlug = item.dataset.plats;
          document
            .querySelector('.tab-wrapper.active')
            .classList.remove('active');
          document.getElementById(itemSlug).classList.add('active');

          submenuChange(item, 'plats', itemSlug);
        }
      });

      // let plats = this.dataset.plats;

      // const param = {};
      // param['action'] = 'get_contact_list';
      // param['plats'] = plats;
      // param['id'] = document.querySelector(
      //   '.contact-main-wrapper'
      // ).dataset.id;
      // const url = document.getElementById('contactAjaxURL').dataset.url;

      // // prettier-ignore
      // jQuery.ajax({
      //   url: url,
      //   type: 'post',
      //   data: param,
      //   error: function(errorThrown){console.log(errorThrown);

      //   },
      //   beforeSend: function () {

      //   },
      //   success: function(response) {
      //       submenuChange(item, 'plats', plats);
      //       document.querySelector('.contact-main-wrapper').innerHTML = response;
      //   },
      // });
      // });
    });

  // submenu: production on click
  document
    .querySelectorAll('.production-submenu-wrapper.submenu-wrapper li')
    .forEach(function (item) {
      item.addEventListener('click', function () {
        if (!item.classList.contains('active')) {
          const itemSlug = item.dataset.slug;

          document
            .querySelector('.tab-wrapper.active')
            .classList.remove('active');
          document.getElementById(itemSlug).classList.add('active');

          animateGridItem();
          submenuChange(item, 'section', itemSlug);
        }
      });
    });

  // menu links on hover
  document.querySelectorAll('#navigation li').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      linkMouseEnter(item);
    });

    item.addEventListener('mouseleave', function () {
      linkMouseLeave(item);
    });
  });

  // sub menu links on hover
  document.querySelectorAll('.submenu-content ul li').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      linkMouseEnter(item);
    });

    item.addEventListener('mouseleave', function () {
      linkMouseLeave(item);
    });
  });

  // on mouse leave navigation
  document
    .getElementById('navigation')
    .addEventListener('mouseleave', function () {
      const wW = window.innerWidth;

      if (wW > __MOBILE_BREAKPOINT && this.classList.contains('is-active')) {
        closeMenu();
      }
    });

  // ***** FUNCTIONS ***** //

  function loadPage() {
    redesignVimeo();
    // loadMenuLinks();
    changeMenuTheme();
    loadSliders();
    resizeIcons();
    submenuLoad();
    animateGridItem();
    vimeoPlayer();
    loadServiceForm();
  }
  /**
   * Click hamburger menu or close menu button
   * @param  {} item
   */
  function onClickMenu(item) {
    const nav = document.getElementById('navigation'),
      burger = document.querySelector('.hamburger'),
      menuLabel = burger.querySelector('.menu-label'),
      logo = document.querySelector('.main-logo .logo'),
      submenu = document.querySelector('.submenu-wrapper'),
      headerNav = document.querySelector('.header-nav');

    const wW = window.innerWidth;

    // collapse menu
    if (burger.classList.contains('is-active')) {
      closeMenu();
    } else {
      // expand menu
      // show menu or language list
      if (item.classList.contains('hamburger')) {
        nav.querySelector('.menu-list').classList.add('active');
        nav.querySelector('.language-list').classList.remove('active');
      } else {
        nav.querySelector('.language-list').classList.add('active');
        nav.querySelector('.menu-list').classList.remove('active');
      }

      setTimeout(function () {
        logo.src = logo.getAttribute('rel-alt-logo');
      }, 500);

      burger.classList.add('is-active');
      nav.classList.add('is-active');
      logo.src = logo.getAttribute('rel-alt-logo');
      menuLabel.innerHTML = menuLabel.getAttribute('rel-label-close');

      // if submenu is sticky
      // prettier-ignore
      if (submenu && submenu.classList.contains('stick')) {
        const menuH = getHeight(nav);
        submenu.style.top = menuH + 'px';
      }

      // hide language switcher
      if (wW > __MOBILE_BREAKPOINT) {
        document.querySelector(
          '.header-right-content .language-wrapper'
        ).style.display = 'none';
      }

      // show border on header nav
      if (!headerNav.classList.contains('.dark')) {
        headerNav.classList.add('line');
      }
    }
  }

  /**
   * Close menu
   */
  function closeMenu() {
    const nav = document.getElementById('navigation'),
      burger = document.querySelector('.hamburger'),
      menuLabel = burger.querySelector('.menu-label'),
      logo = document.querySelector('.main-logo .logo'),
      submenu = document.querySelector('.submenu-wrapper'),
      headerNav = document.querySelector('.header-nav');

    const wW = window.innerWidth;

    if (document.querySelector('.header-nav').classList.contains('light')) {
      setTimeout(function () {
        logo.src = logo.getAttribute('rel-main-logo');
      }, 300);
    }
    burger.classList.remove('is-active');
    nav.classList.remove('is-active');
    menuLabel.innerHTML = menuLabel.getAttribute('rel-label-menu');

    // if submenu is sticky
    // prettier-ignore
    if (submenu && submenu.classList.contains('stick')) {
      const headerNav = document.querySelector('.header-nav'),
      menuH = getHeight(headerNav) + headerNav.getBoundingClientRect().top;
    
      submenu.style.top = menuH + 'px';
    }

    if (wW > __MOBILE_BREAKPOINT) {
      // show language switcher
      document.querySelector(
        '.header-right-content .language-wrapper'
      ).style.display = 'block';
    }

    // hide border on header nav
    if (headerNav.classList.contains('line')) {
      headerNav.classList.remove('line');
    }
    // expand menu
  }

  /**
   * Load all sliders for every page
   */
  function loadSliders() {
    if (document.querySelector('.product-slider')) {
      document
        .querySelectorAll('.product-slider-wrapper')
        .forEach(function (item) {
          const sliderID = '#' + item.querySelector('.product-slider').id;

          new Splide(sliderID, {
            pagination: true,
            arrows: true,
            cover: true,
            type: 'loop',
            classes: {
              // Add classes for arrows.
              prev: 'splide__arrow--prev btn round-btn',
              next: 'splide__arrow--next btn round-btn',
            },
            breakpoints: {
              900: {
                arrows: false,
              },
            },
          }).mount();
        });
    }

    if (document.querySelector('.service-slider')) {
      document
        .querySelectorAll('.service-slider-wrapper')
        .forEach(function (item) {
          const sliderID = '#' + item.querySelector('.service-slider').id;

          new Splide(sliderID, {
            pagination: true,
            arrows: true,
            cover: true,
            type: 'loop',
            classes: {
              // Add classes for arrows.
              prev: 'splide__arrow--prev btn round-btn',
              next: 'splide__arrow--next btn round-btn',
            },
            breakpoints: {
              900: {
                arrows: false,
              },
            },
          }).mount();
        });
    }

    if (document.querySelector('.nav-submenu-slider')) {
      new Splide('.nav-submenu-slider', {
        pagination: false,
        arrows: true,
        perPage: 5,
        perMove: 1,
        arrowPath: '',
        classes: {
          // Add classes for arrows.
          prev: 'splide__arrow--prev nav-arrow',
          next: 'splide__arrow--next nav-arrow',
        },
        breakpoints: {
          900: {
            destroy: true,
          },
        },
      }).mount();
    }
  }

  function redesignVimeo() {
    var $iframe = jQuery('#videoplayer');
    var $poster = jQuery('.poster-img');
    var ratio = 0.563;
    // var ratio = 0.3459;
    var posterRel = $poster.attr('rel');
    posterRel = ''; //to be deleted

    let wrap = jQuery(window);

    // var width = jQuery('.video-wrapper').width();
    var calcHeight = wrap.width() * ratio;
    var calcWidth = wrap.height() / ratio + 1;
    if (wrap.width() > calcWidth) {
      var windWidth = wrap.width() + 1;
      $poster.attr(
        'style',
        posterRel + 'width:' + windWidth + 'px;height:' + calcHeight + 'px;'
      );
      $iframe.attr(
        'style',
        'width:' + windWidth + 'px;height:' + calcHeight + 'px;'
      );
    } else {
      // $poster.attr('style', posterRel+'width:'+calcWidth+'px;height:'+jQuery(window).height()+'px;');
      // $iframe.attr('style', 'width:'+calcWidth+'px;height:'+jQuery(window).height()+'px;');
      $poster.css('width', calcWidth + 'px');
      $poster.css('height', '100vh');

      // attr(
      //   'style',
      //   posterRel + 'width:' + calcWidth + 'px;height:100vh'
      // );
      $iframe.attr('style', 'width:' + calcWidth + 'px;height:100vh');
    }
  }

  /**
   * Change color of header logo and
   * menu depending on background color of section
   */
  function changeMenuTheme() {
    document.querySelectorAll('.bg-light').forEach(function (element) {
      let menuH =
          document.querySelector('.header-nav').offsetTop +
          getHeight(document.querySelector('.header-nav')),
        whiteOffset = element.getBoundingClientRect().top,
        whiteH = getHeight(element) + whiteOffset,
        header = document.querySelector('.header-nav'),
        logo = document.querySelector('.main-logo .logo');

      let wW = window.innerWidth;

      if (wW > __MOBILE_BREAKPOINT) {
        // SOCIAL MEDIA ICONS
        // prettier-ignore
        const socialMedia = document.querySelectorAll('.social-icons-container')[1],
          socialMediaTop = socialMedia.getBoundingClientRect().top,
          socialMediaH = socialMediaTop + getHeight(socialMedia);

        if (whiteOffset <= socialMediaH && whiteH >= socialMediaH) {
          socialMedia.querySelectorAll('.social-icon').forEach(function (item) {
            // prettier-ignore
            item.src = item.getAttribute('rel-alt-logo');
          });
        } else {
          socialMedia.querySelectorAll('.social-icon').forEach(function (item) {
            // prettier-ignore
            item.src = item.getAttribute('rel-main-logo');
          });
        }
      }

      // MENU
      if (whiteOffset - menuH <= 0 && whiteH > 0) {
        element.classList.add('active');
        if (header.classList.contains('light')) {
          header.classList.remove('light');
          header.classList.add('dark');

          // prettier-ignore
          logo.src = document.querySelector('.main-logo .logo').getAttribute('rel-alt-logo');
        }
        return false;
      } else {
        element.classList.remove('active');
        if (document.querySelectorAll('.bg-light.is-active').length <= 0) {
          if (header.classList.contains('line')) {
            header.className = '';
            header.className = 'header-nav light line';
          } else {
            header.className = '';
            header.className = 'header-nav light';
          }
          // header.className = '';
          // header.className = 'header-nav light';

          // if nav is expanded
          // prettier-ignore
          if (!document.getElementById('navigation').classList.contains('is-active')) {
            logo.src = document
              .querySelector('.main-logo .logo')
              .getAttribute('rel-main-logo');
          }
        }
      }
    });
  }

  function stickySubmenu() {
    const submenu = document.querySelector('.submenu-wrapper'),
      nav = document.getElementById('navigation');

    let menu = document.querySelector('.header-nav');

    // if navistion is expanded, attach submenu to the bottom of main nav menu.
    if (nav.classList.contains('is-active')) {
      menu = nav;
    }

    if (document.querySelector('.submenu-wrapper')) {
      const menuH = getHeight(menu) + menu.getBoundingClientRect().top,
        bodyContainer =
          document.querySelector('.main-container').getBoundingClientRect()
            .top + document.documentElement.scrollTop,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop >= bodyContainer - menuH) {
        if (!submenu.classList.contains('stick')) {
          submenu.classList.add('stick');
          submenu.style.top = menuH + 'px';
        }
      } else {
        submenu.classList.remove('stick');
        submenu.style.top = '';
      }
    }
  }

  function resizeIcons() {
    let wW = window.innerWidth;

    if (wW <= __MOBILE_BREAKPOINT) {
      // Change all social icons to black
      const socialMedia = document.querySelector(
        '.navigation-content .social-icons-container'
      );

      socialMedia.querySelectorAll('.social-icon').forEach(function (item) {
        // prettier-ignore
        item.src = item.getAttribute('rel-alt-logo');
      });
    }
  }

  /**
   * Populate submenu
   */
  function submenuLoad() {
    let wW = window.innerWidth;

    if (document.querySelector('.submenu-wrapper')) {
      const submenuDrop = document
        .querySelector('.submenu-wrapper')
        .querySelector('.submenu-drop');

      if (wW <= __MOBILE_BREAKPOINT) {
        //prettier-ignore
        let activeSubmenu = document.querySelector('.submenu-content li.active').innerText.trim();

        submenuDrop.innerText = activeSubmenu;
        submenuDrop.classList.add('active');

        if (document.querySelectorAll('.submenu-content li').length == 1) {
          submenuDrop.classList.add('disabled');
        }
      } else {
        submenuDrop.classList.remove('active');
        submenuDrop.classList.remove('disabled');
      }
    }
  }

  /**
   * Refresh menu on resize
   */
  function menuReload() {
    let wW = window.innerWidth;
    if (wW <= __MOBILE_BREAKPOINT) {
      // hide language switcher
      document.querySelector(
        '.header-right-content .language-wrapper'
      ).style.display = 'none';
    } else {
      // show language switcher
      document.querySelector(
        '.header-right-content .language-wrapper'
      ).style.display = 'block';
    }
  }
  /**
   * common function for submenu
   * On submenu click
   * @param  {} item
   * @param  {} param
   * @param  {} paramVal
   */
  function submenuChange(item, param, paramVal) {
    document
      .querySelector('.submenu-wrapper li.active')
      .classList.remove('active');

    item.classList.add('active');

    // Construct URLSearchParams object instance from current URL querystring.
    var queryParams = new URLSearchParams(window.location.search);

    // Set new or modify existing parameter value.
    queryParams.set(param, paramVal);

    // Replace current querystring with the new one.
    history.replaceState(null, null, '?' + queryParams.toString());
  }

  /**
   * on dropdown click
   * @param  {} item
   */
  function dropdownClick(item) {
    item.addEventListener('click', function () {
      let panel = this.parentElement.querySelector('.drop-content'),
        dropWrapper = this.closest('.drop-wrapper');

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        // panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.style.maxHeight = '10000px';
      }

      if (dropWrapper.classList.contains('is-active')) {
        dropWrapper.classList.remove('is-active');
        this.classList.remove('active');
      } else {
        dropWrapper.classList.add('is-active');
        this.classList.add('active');
      }
    });
  }

  /**
   * Animate on scroll on scroll/load
   */
  function animateGridItem() {
    if (document.querySelector('.grid-wrapper')) {
      document.querySelectorAll('.grid-item').forEach(function (element) {
        const imgBox = element.querySelector('.img-box'),
          vHeight = window.innerHeight || document.documentElement.clientHeight;

        let rect = imgBox.getBoundingClientRect();

        /* prettier-ignore */
        if  ((rect.top > 0 || rect.bottom > 0) && rect.top <  vHeight) {
           // if in viewport
          if (imgBox.classList.contains('is-out')) {
            imgBox.classList.remove('is-out');
            imgBox.classList.add('is-in');

            if (imgBox.classList.contains('is-out--down')) {
              imgBox.classList.remove('is-out--down');
              imgBox.classList.add('is-in--down');
            } else {
              imgBox.classList.remove('is-out--up');
              imgBox.classList.add('is-in--up');
            }

          }
        } else {
          // if not in viewport

            if (rect.top <= 0) {
              // if not in viewport from the top
              if (imgBox.classList.contains('is-in')) {
                imgBox.classList.remove('is-in');
                imgBox.classList.add('is-out');

                imgBox.classList.remove('is-in--down');
                imgBox.classList.remove('is-out--down');
                imgBox.classList.add('is-out--up');

              }

            } else {
              // if not in viewport from the bottom
              if (imgBox.classList.contains('is-in')) {
                imgBox.classList.remove('is-in');
                imgBox.classList.add('is-out');

                imgBox.classList.remove('is-in--up');
                imgBox.classList.remove('is-out--up');
                imgBox.classList.add('is-out--down');
              }
            }
        }
      });
    }
  }

  // /**
  //  * @param  {} element
  //  * @param  {} scrollSpeed
  //  */
  // function scrollTransform(element, scrollSpeed = null) {
  //   const imgBox = element.querySelector('.img-box'),
  //     scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //   if (scrollSpeed == null) {
  //     scrollSpeed = imgBox.getAttribute('data-scroll-speed');
  //   }

  //   imgBox.style.transform =
  //     'translate3d(0px,' + -(scrollTop / scrollSpeed) + 'px, 0px)';
  // }

  /**
   * Vimeo Player
   */
  function vimeoPlayer() {
    videoPlayer = document.querySelector('#videoplayer');
    if (videoPlayer) {
      videoPlayer = new Player(videoPlayer);

      videoPlayer.on('play', function () {
        document.querySelector('.poster-img').style.display = 'none';
      });

      $('.poster-img').fadeOut(2000);
    }
  }

  function onResizeLoad() {
    const wW = window.innerWidth;
    if (wW > __MOBILE_BREAKPOINT && document.querySelector('.poster-img')) {
      $('.poster-img').fadeOut(500);
    }
  }

  /**
   * Main link on mouse enter/hover in
   * @param  {} item
   */
  function linkMouseEnter(item) {
    item.classList.add('opacity');
    setTimeout(function () {
      item.classList.remove('opacity');
      item.classList.add('hover');
    }, 100);
  }

  /**
   * Main link on mouse leave/hover out
   * @param  {} item
   */
  function linkMouseLeave(item) {
    item.classList.add('opacity');
    setTimeout(function () {
      item.classList.remove('opacity');
      item.classList.remove('hover');
    }, 300);
  }

  /**
   * Load service form (form files)
   */
  function loadServiceForm() {
    const formFiles = document.querySelectorAll('.service-form-files');
    if (formFiles.length > 0) {
      formFiles.forEach(function (item) {
        const form = item.querySelector('.service-form');

        if (localStorage.getItem('setFormFileLoad_' + form.id) === 'set') {
          form.style.display = 'none';

          var action = 'form_file_retrieve';
          var url = form.dataset.url;
          let data = new FormData(form);
          data.append('action', action);

          // prettier-ignore
          fetch(url + '?' + new URLSearchParams({
                'action': action }), { method: 'GET'})
            .then(function (response) {
              if (!response.ok) {
                throw Error(response.statusText);
              }
              return response.text();
            })
            .then(function (response) {
              item.querySelector('.service-content-inner').innerHTML = response;
              const contentFormH = document.querySelector(
                '.drop-wrapper.is-active .drop-content-inner'
              ).offsetHeight;
              document.querySelector(
                '.drop-wrapper.is-active .drop-content'
              ).style.maxHeight = contentFormH + 'px';
              
            })
            .catch(function (e) {
              console.log(e);
            });
        }
      });
    }
  }

  function hideMainMenu() {
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop) {
      // downscroll code

      const wW = window.innerWidth;

      if (
        wW > __MOBILE_BREAKPOINT &&
        document.getElementById('navigation').classList.contains('is-active')
      ) {
        closeMenu();
      }
    } else {
      // upscroll code
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }

  // function loadMenuLinks() {
  //   document.querySelectorAll('#navigation li').forEach(function (item) {
  //     resizeMainLinks(item);
  //   });

  //   document
  //     .querySelectorAll('.submenu-content ul li')
  //     .forEach(function (item) {
  //       resizeMainLinks(item);
  //     });
  // }

  // function resizeMainLinks(item) {
  //   const itemW = getWidth(item);

  //   if (itemW < 50) {
  //     item.style.width = '';
  //   } else {
  //     setTimeout(function () {
  //       item.style.width = itemW + 10 + 'px';
  //     }, 1000);
  //   }
  // }

  // Update Reklamation case number
  function updateCaseNumber() {
    const param = {};
    let caseNum = parseInt(
      document.querySelector('.wpcf7-text.case-number').value
    );
    param['action'] = 'update_case_number';
    param['caseNum'] = caseNum;

    const url = document.getElementById('service-content-2').dataset.url;

    // prettier-ignore
    jQuery.ajax({
      url: url,
      type: 'post',
      data: param,
      error: function(errorThrown){console.log(errorThrown);

      },
      beforeSend: function () {
        
      },
      success: function() {
        caseNum++;
        document.querySelector('.wpcf7-text.case-number').value = caseNum;
      },
    });
  }

  // ***** HELPER FUNCTIONS ***** //

  // Get Element Height
  function getHeight(elem) {
    var widthCalced = 0;
    var rect = elem.getBoundingClientRect();
    if (rect.height) {
      widthCalced = parseFloat(rect.height);
    } else {
      widthCalced = parseFloat(rect.bottom - rect.top);
    }
    return widthCalced;
  }

  // Get Element Width
  // function getWidth(elem) {
  //   var widthCalced = 0;
  //   var rect = elem.getBoundingClientRect();
  //   if (rect.width) {
  //     widthCalced = parseFloat(rect.width);
  //   } else {
  //     widthCalced = parseFloat(rect.right - rect.left);
  //   }
  //   return widthCalced;
  // }

  // function random_item(items) {
  //   return items[Math.floor(Math.random() * items.length)];
  // }
});



// WEBPACK FOOTER //
// resources/assets/scripts/main.js